export const SET_PRODUTO = 'SET_PRODUTO'
export const SET_LOADING = 'SET_LOADING'